import { render, staticRenderFns } from "./ScanNfcOffline.vue?vue&type=template&id=853d208a"
import script from "./ScanNfcOffline.vue?vue&type=script&lang=js"
export * from "./ScanNfcOffline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports